import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const forWho = ['Padres que buscan alternativas seguras y naturales para sus hijos.', 'Adultos cansados de la acidez y los efectos secundarios de los analgésicos.', 'Personas que viven lejos de una farmacia o quieren ahorrar dinero.', 'Entusiastas de lo natural que quieren resultados científicos, no esotéricos.'];
const notForWho = ['Personas que buscan una cura mágica para enfermedades crónicas graves.', 'Quienes prefieren tomar una pastilla química por pereza de hervir agua.', 'Quienes ignoran las advertencias médicas y no consultan a su doctor.'];
export function AudienceSection() {
  return <section className="py-12 md:py-24 px-4 bg-cream-100 relative" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-6 md:gap-12" data-id="element-3">
          {/* Para quién SÍ es */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="p-8 rounded-sm bg-white border-t-4 border-forest-700 shadow-xl" data-id="element-4">
            <h3 className="text-2xl font-playfair font-bold text-forest-900 mb-8 flex items-center gap-3" data-id="element-5">
              <CheckCircle2 className="text-forest-700" size={28} data-id="element-6" />
              Para quién SÍ es
            </h3>
            <ul className="space-y-6" data-id="element-7">
              {forWho.map((text, index) => <li key={index} className="flex items-start gap-4" data-id="element-8">
                  <div className="mt-1 flex-shrink-0 text-forest-700" data-id="element-9">
                    <CheckCircle2 size={20} data-id="element-10" />
                  </div>
                  <p className="font-lora text-ink-800 leading-relaxed" data-id="element-11">
                    {text}
                  </p>
                </li>)}
            </ul>
          </motion.div>

          {/* Para quién NO es */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="p-8 rounded-sm bg-cream-200 border-t-4 border-red-800/80 shadow-md opacity-90" data-id="element-12">
            <h3 className="text-2xl font-playfair font-bold text-ink-900 mb-8 flex items-center gap-3" data-id="element-13">
              <XCircle className="text-red-800/80" size={28} data-id="element-14" />
              Para quién NO es
            </h3>
            <ul className="space-y-6" data-id="element-15">
              {notForWho.map((text, index) => <li key={index} className="flex items-start gap-4" data-id="element-16">
                  <div className="mt-1 flex-shrink-0 text-red-800/80" data-id="element-17">
                    <XCircle size={20} data-id="element-18" />
                  </div>
                  <p className="font-lora text-ink-800/80 leading-relaxed" data-id="element-19">
                    {text}
                  </p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}